// Copyright (C) 2020 TANNER AG

import { graphql } from "react-apollo";
import { compose } from "recompose";
import withLocalization from "./withLocalization";
import withFlattenedTranslations from "./withFlattenedTranslations";
import withLoadingState from "./withLoadingState";
import withErrorState from "./withErrorState";
import withConnectionStatus from "./withConnectionStatus";
import tSChapterQuery from "../queries/tSChapter";

const buildQueryOptions = ({ slug, language, fetchPolicy, stage }) => {
    return {
        variables: {
            slug,
            stage,
            lang: language.toLowerCase(),
        },
        fetchPolicy,
    };
};

export default (customLoadingComponent) =>
    compose(
        withConnectionStatus,
        withLocalization,
        graphql(tSChapterQuery, {
            options: (props) => {
                return buildQueryOptions(props);
            },
        }),
        withErrorState,
        withLoadingState("eMobilityChapter", customLoadingComponent, customLoadingComponent),
        withFlattenedTranslations("eMobilityChapter")
    );



// WEBPACK FOOTER //
// ./src/hocs/withTSChapter.js